/** @jsxImportSource react */
import type { SVGProps } from 'react';
const OpenInNew = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M8 4.5A.75.75 0 1 0 7.99 3h-.127c-1.03 0-1.72 0-2.303.181A4 4 0 0 0 2.931 5.81c-.182.583-.181 1.272-.181 2.303v6.97c0 .882 0 1.59.047 2.163.048.588.15 1.099.389 1.57a4 4 0 0 0 1.748 1.748c.471.24.982.341 1.57.39C7.077 21 7.785 21 8.668 21h6.97c1.03 0 1.719 0 2.302-.181a4 4 0 0 0 2.629-2.629c.181-.583.181-1.272.181-2.303v-.137a.75.75 0 1 0-1.5 0c0 1.22-.009 1.658-.113 1.994a2.5 2.5 0 0 1-1.643 1.643c-.336.104-.775.113-1.994.113H8.7c-.922 0-1.57 0-2.073-.042-.496-.04-.788-.116-1.012-.23a2.5 2.5 0 0 1-1.092-1.093c-.115-.224-.19-.516-.231-1.012-.041-.504-.042-1.15-.042-2.073v-6.8c0-1.22.009-1.658.113-1.994a2.5 2.5 0 0 1 1.643-1.643C6.342 4.51 6.781 4.5 8 4.5"
    />
    <path
      fill="currentColor"
      d="M18.19 4.5H13.5a.75.75 0 0 1 0-1.5h5.72c.122 0 .255 0 .37.01.13.01.3.036.477.126.236.12.427.311.547.547.09.176.116.348.127.478.009.114.009.247.009.369v5.72a.75.75 0 0 1-1.5 0V5.56L9.03 15.78a.75.75 0 0 1-1.06-1.06z"
    />
  </svg>
);
export default OpenInNew;
